import { FirstPage } from './firstPage';
import { ThirdPage } from './thirdPage';
import { SecondPage } from './secondPage';
import { PortCoPageProps } from 'interfaces/components/dashboardPdf';

export const PortCoInfoPage = ({
  data,
  columns,
  pagesCount,
  companyName,
  companyInfo
}: PortCoPageProps) => {
  return (
    <>
      {[FirstPage, SecondPage, ThirdPage].map((Comp, i) => (
        <Comp
          key={i}
          data={data}
          pagesCount={pagesCount}
          companyName={companyName}
          companyInfo={companyInfo}
          columns={['title', ...columns]}
        />
      ))}
    </>
  );
};
